import React from 'react';
import ChevronIcon from 'components/assets/ChevronIcon';
import A from '../A/A';
import classes from './BackButton.module.scss';

export interface Props {
  to?: string;
  onClick?: () => void;
}

const BackButton: React.FC<Props> = ({ onClick, to }: Props) => {
  if (to) {
    return (
      <A to={to} className={classes.backBtn} aria-label="back">
        <ChevronIcon color="#1c2451" />
      </A>
    );
  } else {
    return (
      <button onClick={onClick} className={classes.backBtn} aria-label="back">
        <ChevronIcon color="#1c2451" />
      </button>
    );
  }
};

export default BackButton;
